export const ONE_ROW_BREAKPOINT = '(max-width: 1065px)';
export const TWO_ROWS_BREAKPOINT = '(max-width: 1410px)';
export const MOBILE_BREAKPOINT = '(max-width: 480px)';
